import React from 'react'
import './ToggleSegmentButtons.component.css'
import SegmentButtons, { ISegmentButtons } from '../SegmentButtons.component'

export const ToggleSegmentButtons: React.FC<ISegmentButtons> = (props: ISegmentButtons) => {
  const { className, ...remainingProps } = props
  return <SegmentButtons className={className + ' toggle-segmented-group'} {...remainingProps} />
}
